module.exports = __webpack_public_path__ + "static/img/twitter.2adea16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/twitter.png
// module id = HzLV
// module chunks = 1